import axiosClient from '@clients/axiosClient';

export type IStartOperatorSession = { customerId: number; accountId: number };
export type IEndOperatorSession = {
    protocol: string;
    additionalInfo: AdditionalInfo;
} & IStartOperatorSession;

export type Resolution = 'RESOLVED' | 'UNRESOLVED' | 'OPEN';

export type AdditionalInfo = {
    text: string;
    resolution?: Resolution;
};

export interface OperatorSession {
    protocol: string;
}

const operatorSession = () => {
    const client = axiosClient();

    return {
        async startOperatorSession({
            accountId,
            customerId,
        }: IStartOperatorSession) {
            const { data } = await client.post<OperatorSession>(
                `/crm/v1/customers/${customerId}/accounts/${accountId}/protocol`,
                null,
            );
            return data;
        },
        async endOperatorSession({
            accountId,
            customerId,
            protocol,
            additionalInfo,
        }: IEndOperatorSession) {
            const { data } = await client.post(
                `/crm/v1/customers/${customerId}/accounts/${accountId}/protocol/${protocol}/close`,
                { additional_info: additionalInfo },
            );
            return data;
        },
    };
};

export default operatorSession;
